var map = {
	"./blog.yml": 104,
	"./cloud.yml": 105,
	"./color.yml": 106,
	"./country.yml": 107,
	"./dio.yml": 108,
	"./doc.yml": 109,
	"./emoji.yml": 110,
	"./flag.yml": 111,
	"./git.yml": 112,
	"./icon.yml": 113,
	"./license.yml": 114,
	"./link.yml": 115,
	"./metrics.yml": 116,
	"./people.yml": 117,
	"./soft.yml": 118,
	"./src.yml": 119,
	"./status.yml": 120,
	"./taxonomy.yml": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;